import React from "react";
import styled from "styled-components";

const Svg = styled.svg`
  z-index: 2;
`;

const MessageIcon = props => {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="18.075"
      height="14.349"
      viewBox="0 0 18.075 14.349"
      {...props}
    >
      <defs>
        <clipPath id="a">
          <rect width="18.075" height="14.349" fill="none" />
        </clipPath>
      </defs>
      <g clipPath="url(#a)">
        <path
          d="M61.464,51.473h-9.15a4.168,4.168,0,0,1-4.163-4.163V41.887a4.168,4.168,0,0,1,4.163-4.163h9.15a4.168,4.168,0,0,1,4.163,4.163V47.31A4.168,4.168,0,0,1,61.464,51.473Zm-9.15-13.384a3.8,3.8,0,0,0-3.8,3.8V47.31a3.8,3.8,0,0,0,3.8,3.8h9.15a3.8,3.8,0,0,0,3.8-3.8V41.887a3.8,3.8,0,0,0-3.8-3.8Z"
          transform="translate(-47.852 -37.424)"
          fill="#455ee5"
          stroke="#455ee5"
          strokeWidth="0.6"
        />
        <path
          d="M56.556,45.659a2.513,2.513,0,0,1-1.791-.742l-5.624-5.623.258-.258,5.624,5.624a2.169,2.169,0,0,0,3.066,0l5.889-5.889.257.258-5.889,5.888A2.511,2.511,0,0,1,56.556,45.659Z"
          transform="translate(-47.781 -37.349)"
          fill="#455ee5"
          stroke="#455ee5"
          strokeWidth="0.6"
        />
      </g>
    </Svg>
  );
};

export default MessageIcon;
